/*
 *
 * ForgotPasswordPage Form
 *
 */

import React from "react";
import { connect } from "react-redux";
import { toast } from "sonner";
import { StyledForm, ButtonGroup } from "./styledComponents";

import Button from "components/Button";
import InputField from "components/InputField";
import { Controller, useForm } from "react-hook-form";
import { t } from "copy/t";
import validate from "./validate";

// Adapter: translate validate()'s flag-shape output into react-hook-form's
// { values, errors } resolver contract without pulling in @hookform/resolvers.
const resolver = (values) => {
  const validationErrors = validate(values);
  const errors = {};
  if (validationErrors.password) {
    errors.password = { type: "validate", ...validationErrors.password };
  }
  if (validationErrors.password_confirmation) {
    errors.password_confirmation = { type: "validate", message: "Passwords must match." };
  }
  return { values: Object.keys(errors).length ? {} : values, errors };
};

const Form = ({
  onSubmit,
  pristine,
  submitting,
  initialValues,
  openInvalidPasswordModal,
  openPasswordRequirementsModal,
}) => {
  const form = useForm({
    defaultValues: initialValues,
    resolver,
    mode: "onSubmit",
  });
  const { control } = form;

  const onInvalid = (formErrors) => {
    if (formErrors.password) {
      openInvalidPasswordModal({ ...formErrors.password });
    } else if (formErrors.password_confirmation) {
      toast.error(t("toast.passwordsMustMatch"));
    }
  };

  return (
    <StyledForm onSubmit={form.handleSubmit(onSubmit, onInvalid)}>
      <Controller
        control={control}
        name="password"
        render={({ field: { ref, ...fieldRest } }) => (
          <InputField
            name="password"
            type="password"
            component={InputField}
            label="New Password"
            placeholder={t("placeholders.passwordDots")}
            showPasswordButton={false}
            helpIcon={true}
            helpEvent={openPasswordRequirementsModal}
            isSignup
            field={fieldRest}
            {...fieldRest}
          />
        )}
      />
      <Controller
        control={control}
        name="password_confirmation"
        render={({ field: { ref, ...fieldRest } }) => (
          <InputField
            name="password_confirmation"
            type="password"
            label="Repeat New Password"
            placeholder={t("placeholders.passwordDots")}
            showPasswordButton={false}
            helpIcon={true}
            helpEvent={openPasswordRequirementsModal}
            field={fieldRest}
            {...fieldRest}
          />
        )}
      />
      <Controller
        control={control}
        name="reset_password_token"
        render={({ field: { ref, ...fieldRest } }) => (
          <input type="hidden" {...fieldRest} />
        )}
      />
      <ButtonGroup>
        <Button type="submit" disabled={submitting}>
          Confirm New Password
        </Button>
      </ButtonGroup>
    </StyledForm>
  );
};

export default connect()(Form);
